const domain = `http://www.sydev.info`
const prefix = process.env.NODE_ENV === 'development' ? domain : ``
export default Object.freeze({
  api: `${prefix}/our-story/api`,
})
